import React from "react";
import OurStory from "../components/OurStory";
import AchievementsSection from "./Achievements/AchievementSection";

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        {/* Hero Section */}
        <div
          className="relative bg-no-repeat bg-center bg-contain py-20 sm:py-32 md:py-44"
          style={{
            backgroundImage: "url('https://i.ibb.co/B4fwJqv/gamind-logo.jpg')",
            
          }}
        >
          <div className="absolute inset-0 bg-black opacity-70"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-2 relative z-10">
              About Gam-Ind Association
            </h1>
            <p className="text-lg sm:text-xl text-gray-100">
              Empowering Gambian Students in India since 2017
            </p>
          </div>
        </div>

        {/* Our story Section */}
        <OurStory />

        {/* Mission and Values */}
        <section className="py-12 sm:py-16 px-4 sm:px-8 md:px-16 bg-gray-100">
          <div className="container mx-auto">
            <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8 sm:mb-12 text-indigo-700">
              Our Mission and Values
            </h2>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-2xl sm:text-3xl font-semibold mb-2 text-indigo-700">
                  Mission
                </h3>
                <p className="text-sm sm:text-md text-gray-700">
                  To support, defend, and improve the welfare of all Gambian
                  students in India, addressing academic and social issues while
                  promoting cultural understanding and personal development.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-2xl sm:text-3xl font-semibold mb-2 text-indigo-700">
                  Values
                </h3>
                <ul className="list-none space-y-2 text-gray-700">
                  <li className="text-sm sm:text-md before:content-['➤'] before:text-indigo-600 before:mr-2 before:inline-block">
                    Unity and Collaboration
                  </li>
                  <li className="text-sm sm:text-md before:content-['➤'] before:text-indigo-600 before:mr-2 before:inline-block">
                    Cultural Exchange
                  </li>
                  <li className="text-sm sm:text-md before:content-['➤'] before:text-indigo-600 before:mr-2 before:inline-block">
                    Academic Excellence
                  </li>
                  <li className="text-sm sm:text-md before:content-['➤'] before:text-indigo-600 before:mr-2 before:inline-block">
                    Personal Growth
                  </li>
                  <li className="text-sm sm:text-md before:content-['➤'] before:text-indigo-600 before:mr-2 before:inline-block">
                    Community Services
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Team Members */}
        <section className="py-12 px-4 sm:px-8 md:px-16 bg-white">
          <div className="container mx-auto">
            <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8 sm:mb-12 text-indigo-700">
              The Gam-Ind 9th Executive Council
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-8">
              {teamMembers.map((member, index) => (
                <div key={index} className="text-center">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-20 h-20 sm:w-28 sm:h-40 rounded-lg mx-auto mb-2 sm:mb-4 object-cover"
                  />
                  <h3 className="text-sm sm:text-md font-semibold">{member.name}</h3>
                  <p className="text-gray-600 text-xs sm:text-sm">{member.position}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Achievements Section */}
        <AchievementsSection />
      </main>
    </div>
  );
};

// Team members data
const teamMembers = [
  { name: "Mr. Sarjo A.K. Jarju ", position: "President ", image: "https://i.ibb.co/bgvwxdbD/sarjo.jpg" },
  { name: "Mr. Modou Lewis", position: "Vice President", image: "https://i.ibb.co/d4YcPgK1/lewis.png" },
  { name: "Mr. Moses Oumpa Naterse Dobasin", position: "Secretary General", image: "https://i.ibb.co/whSJPcm2/moses.png" },
  { name: "Mr. David S. Gibba", position: "Ass. Secretary General", image: "https://i.ibb.co/CpGHNKMf/david.jpg" },
  { name: "Mr. Ebrima YS Cham", position: "Finance Minister", image: "https://i.ibb.co/RT8zSVgx/ys.jpg" },
  { name: "Ms. Kadijatou Jallow", position: "Deputy Finance Minister", image: "https://i.ibb.co/CKQNcvf/Accademic-Secretary-Kadijatou-jallow.png" },
  { name: "Mr. Sainey Bojang", position: "Auditor General", image: "https://i.ibb.co/wZ0XyPB3/basainey.png" },
  { name: "Mrs. Isatou Jatta", position: "Information and Communication Minister", image: "https://i.ibb.co/gZ9S6Vm9/Aisha.jpg" },
  { name: "Mr. Abdoulie Bawo", position: "Deputy Information and Communication Minister", image: "https://i.ibb.co/CqfCrg7/bawo.png" },
  { name: "Mr. Mustapha Ceesay", position: "Education Minister", image: "https://i.ibb.co/4RDjz245/mustapha.jpg" },
  { name: "Ms. Fatou Faye", position: "Deputy Education Minister", image: "https://i.ibb.co/Xkjt620g/faye.jpg" },
  { name: "Mrs. Fatoumatta Bittaye", position: "Social & Welfare Minister", image: "https://i.ibb.co/hzz1325/bittaye.png" },
  { name: "Mr. Yaya Jallow", position: "Deputy Social & Welfare Minister ", image: "https://i.ibb.co/CpLCxQ9c/yaya.png" },
  { name: "Ms. Ajaratou Manneh", position: "Logistics Minister ", image: "https://i.ibb.co/h1d5C0bz/ajaratou.png" },
  { name: "Mr. Ebrima Darboe", position: "Deputy Logistics Minister ", image: "https://i.ibb.co/JwRg2gw7/ebrima.jpg" },
];

export default About;
